import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type {
  PortalDigestSettings,
  UpdatePortalDigestSettingsParams,
} from '../model/types';

export const updateDigestSettingsAPI = async (
  params: UpdatePortalDigestSettingsParams,
) => {
  const response = await baseAPI.put<PortalDigestSettings>(
    '/portal-digest/settings',
    params,
  );
  return response.data;
};

export const useUpdateDigestSettings = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateDigestSettingsAPI,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.PORTAL_DIGEST_SETTINGS],
      });
    },
  });
};
